<template>
    <div class="bidding_amount flex flex_center">
        <div class="close_box margin_r">
            <span class="close_icon" :class="{'disabled': isExpired}" @click="clear">x</span>
        </div>
        <div class="flex_1 margin_r">
            <md-field class="bid_input">
                <label>{{$t("revolvingPutOption.premium.withPercent")}}</label>
                <MoneyAmountInput v-model="params.data[params.colDef.field]" :disabled="isExpired"></MoneyAmountInput>
            </md-field>
        </div>
		<el-tooltip placement="top" :open-delay="500"
					:content="$t('investor.exchange.table.operation.makeOffer.premiumRequired')"
					:disabled="hasValue || isExpired"
		>
			<div v-if="!offeredPremium"
				 class="fa_box" :class="{'primary_color': hasValue && !isExpired}" @click="makeOffer">
				<i class="fa fa-legal"></i>
			</div>
			<div v-else
				 class="fa_box" :class="{'primary_color': hasValue && !isExpired}" @click="editOffer">
				<i class="fa fa-legal"></i>
			</div>
		</el-tooltip>
    </div>
</template>

<script>
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";

export default {
    components: {
        MoneyAmountInput
    },
	computed: {
    	hasValue() {
    		return this.params.data[this.params.colDef.field];
		},
    	isExpired() {
    		return this.params.data.expired;
		},
    	offeredPremium() {
    		return this.params.data[this.params.premiumField];
		}
	},
    methods: {
        clear() {
        	if (this.isExpired) {
        		return;
			}

            this.params.data[this.params.colDef.field] = null;
        },
        makeOffer() {
            if (!this.hasValue || this.isExpired) {
                return;
            }

            this.params.makeOffer(this.params.data);
        },
		editOffer() {
			if (!this.hasValue || this.isExpired) {
				return;
			}

			this.params.editOffer(this.params.data);
		}
    }
};
</script>

<style lang="scss" scoped>
@import "src/components/templates/investor/exchange/bidInput.scss";
</style>
